<template>
  <modal
    :disabled="false"
    :modal-open="isModalOpen"
    :toggle-modal="toggleModal"
    :modal-heading="modalHeading"
    :modal-heading-title="modalHeadingText"
  >
    <div
      class="verified-by-lavendla-modal__content"
      v-html="modalDescriptionText"
    />
  </modal>
</template>

<script lang="ts">
import Modal from 'Components/Modal.vue';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'VerifiedModal',

  components: {
    Modal,
  },

  data() {
    return {
      text: window.theme_vars.verified,
    };
  },

  computed: {
    ...mapState('verifiedByLavendla', ['isModalOpen', 'activeCategory']),

    categoryContent() {
      const categories = this.text.categories || {};
      return categories[this.activeCategory] || {};
    },

    modalHeadingText() {
      return this.categoryContent.modalHeading || this.text.modalHeading;
    },

    modalDescriptionText() {
      return (
        this.categoryContent.modalDescription || this.text.modalDescription
      );
    },

    modalHeading() {
      const svg = `
        <svg class="counselor-top-section__verified-icon" aria-hidden="true" viewBox="0 0 21 21">
            <use href="#verified" />
        </svg>
      `;

      return `${svg} ${this.modalHeadingText}`;
    },
  },

  methods: {
    ...mapActions('verifiedByLavendla', ['toggleModal']),
  },
};
</script>
